import { useEffect } from 'react';

const SITE = 'https://dcsportsreport.com';
const DEFAULT_IMAGE =
  'https://customer-assets.emergentagent.com/job_dcsportshub/artifacts/fw8w9adx_DCSportsReport_Logo.png';

export const useSeo = ({ title, description, path, type = 'website', image, noindex = false, jsonLd }) => {
  const jsonLdStr = jsonLd ? JSON.stringify(jsonLd) : '';

  useEffect(() => {
    if (!title) return;

    const ensure = (selector, create) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = create();
        document.head.appendChild(el);
      }
      return el;
    };
    const setMeta = (attr, key, content) => {
      if (content == null) return;
      const el = ensure(`meta[${attr}="${key}"]`, () => {
        const m = document.createElement('meta');
        m.setAttribute(attr, key);
        return m;
      });
      el.setAttribute('content', content);
    };

    const url = `${SITE}${path != null ? path : window.location.pathname}`;

    document.title = title;
    setMeta('name', 'description', description);
    setMeta('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:type', type);
    setMeta('property', 'og:image', image || DEFAULT_IMAGE);
    setMeta('property', 'og:site_name', 'DC Sports Report');
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:url', url);
    setMeta('name', 'twitter:image', image || DEFAULT_IMAGE);

    const canonical = ensure('link[rel="canonical"]', () => {
      const l = document.createElement('link');
      l.setAttribute('rel', 'canonical');
      return l;
    });
    canonical.setAttribute('href', url);

    let script = document.head.querySelector('script[data-seo-jsonld]');
    if (jsonLdStr) {
      if (!script) {
        script = document.createElement('script');
        script.setAttribute('type', 'application/ld+json');
        script.setAttribute('data-seo-jsonld', 'true');
        document.head.appendChild(script);
      }
      script.textContent = jsonLdStr;
    } else if (script) {
      script.remove();
    }
  }, [title, description, path, type, image, noindex, jsonLdStr]);
};
